export const EXCLUDED_INTERCEPTORS_URLS: string[] = [
  'intervista/domande',
  'analytics/message',
];

export const EXCLUDED_ERROR_REDIRECT_URLS: string[] = [
  '/tickets',
  '/v1/admin/asset-users',
  '/v1/superadmin/tenant/',
  '/v1/superadmin/user',
];
